import wrappedFetch from 'common/api/base';

export const createAlgoversePayment = (args: object) => {
  const config = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...args }),
  };

  return wrappedFetch('/algoverse/payment/init', config).then((response) => response.json());
};

export const fetchAlgoverseFundsMargin = () => {
  return wrappedFetch('/algoverse/funds_margin').then((response) => response.json());
};

export const triggerAlgoversePaymentStatusSync = (referenceId: string) => {
  return wrappedFetch(`/algoverse/payment/status?reference_id=${referenceId}`).then((response) =>
    response.json()
  );
};
